const binding = { modules: {}, dataActions: {} };

    (binding.modules['eshop-theme'] = {
        c: () => require('partner/themes/eshop-theme/eshop-theme.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eshop-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'eshop-theme.theme.settings.json',
        md: 'src/themes/eshop-theme'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };